// Point d'entrée historique conservé pour tous les modules consommateurs
// (Dashboard, Ventes, Boutiques, Inventaire, Clients, Comptabilité, Créances):
// même nom, même forme de retour. La logique de bootstrap (fetch + auto-
// provisionnement business/boutique) vit maintenant dans un Provider partagé
// — voir src/contexts/BusinessContext.js pour le pourquoi (elle tournait
// avant indépendamment dans chaque module, sans partage entre pages).
import { useBusinessContextValue } from '../contexts/BusinessContext';

export function useBusinessContext() {
  return useBusinessContextValue();
}

export default useBusinessContext;
